export default "__VITE_ASSET__DHUslqj2__"